import { dummyData } from 'components/guaranteeReturns/constants';

const getGuaranteeReturns = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(dummyData);
    }, 2000);
  });
};

export { getGuaranteeReturns };
